/**
 * useSignalR shim — delegates to the shared hook.
 *
 * The add-in calls useSignalR() with no args; this shim binds
 * orchestratorApi.getPushChannel automatically so callers are unaffected.
 * Optional `UseSignalROptions` (e.g. `onReconnected`) pass through.
 *
 * Shared module: app/common/workflows/signalr/useSignalR (via @product-app alias)
 */

export {
  SIGNALR_METHOD,
  WORKFLOW_EVENT_METHOD,
  WF_EVENT_METHOD,
  _resetUseSignalRForTests,
  type UseSignalRValue,
  type UseSignalROptions,
  type GetPushChannelFn,
} from "@product-app/common/workflows/signalr/useSignalR";

import {
  useSignalR as _useShared,
  type UseSignalROptions,
} from "@product-app/common/workflows/signalr/useSignalR";
import { orchestratorApi } from "../services/orchestratorApi";

export function useSignalR(options: UseSignalROptions = {}) {
  return _useShared((id) => orchestratorApi.getPushChannel(id), options);
}
